import React, { useEffect, useState } from 'react'
import { getRetrieveReportsAAByUserid, getAggregtorAccoutById, getAADigitapByUserid, getAADigitapStatuscheckByUserid } from '../AdminActionCreator.component'
import { formatCurrency, formatDateLatest } from '../../../../utils/commonUtility'
import Nodata from '../../../../images/nodata.png'
import Pagination from '@mui/material/Pagination';
import Loader from '../../../presentationals/Loader/Loader.component'
import Popup from '../../../presentationals/Popup/Popup.component'

export default function AggregatorComponent({ allDetail, customHeaderTenant }) {
  const [loader, setLoader] = useState(false)
  const [DetailsData, setDetailsData] = useState({ parsedData: {}, accountData: {}, holderData: {}, transactions: [] })
  const [currentType, setcurrentType] = useState("")
  const [searchQuery, setSearchQuery] = useState("")
  const [itemsPerPage, setItemsPerPage] = useState(5)
  const [viewDataType, setViewDataType] = useState(true)
  const [currentPage, setCurrentPage] = useState(1)
  const [popup, setPopup] = useState({ show: false, popupStatus: "" });
  const [analysisData, setAnalysisData] = useState(null)
  const [showAnalysisModal, setShowAnalysisModal] = useState(false)

  const fetchData = () => {
    setLoader(true);
    const userId = allDetail?.userId || "";
    getAADigitapStatuscheckByUserid(userId,customHeaderTenant,callback=>{
      console.log("cal",callback)
      if(callback?.data?.txn_status?.[0]?.code == "ReportGenerated"){
        getRetrieveReportsAAByUserid(userId, "raw", customHeaderTenant, (reportData) => {
          if (reportData?.status === 200 && reportData?.data?.transactions) {
            // Map transactions to match existing structure
            const mappedTxns = reportData.data.transactions.map(t => {
              const amtStr = String(t.amount || "0");
              const isCredit = !amtStr.startsWith("-");
              const cleanAmt = Math.abs(parseFloat(amtStr));
              return {
                valueDate: t.date || t.transaction_timestamp || "",
                narration: t.narration || "",
                type: isCredit ? "CREDIT" : "DEBIT",
                amount: cleanAmt,
                currentBalance: parseFloat(t.balance || "0")
              };
            });
    
            // Fetch account details next
            getAggregtorAccoutById(userId, customHeaderTenant, (accountData) => {
              setLoader(false);
              if (accountData?.status === 200 && accountData?.data) {
                setDetailsData({
                  transactions: mappedTxns,
                  accountData: {
                    summary: {
                      status: accountData?.data?.accountType ? "ACTIVE" : "INACTIVE",
                      type: accountData?.data?.accountType || "SAVINGS",
                      ifscCode: accountData?.data?.ifscCode || "—",
                      branch: "—",
                      currentBalance: parseFloat(accountData?.data?.current_balance || "0"),
                      micrCode: accountData?.data?.micrCode || "—"
                    }
                  },
                  holderData: {
                    name: accountData?.data?.HolderName || "—",
                    mobile: accountData?.data?.contactNumber || "—",
                    pan: accountData?.data?.pan || "—",
                    address: accountData?.data?.address || "—"
                  },
                  parsedData: {
                    accounts: [
                      {
                        maskedAccNumber: accountData?.data?.accountNumber || "—"
                      }
                    ]
                  }
                });
                setViewDataType(true);
              } else {
                setViewDataType(false);
                setPopup({ show: true, popupStatus: accountData?.message || "Failed to retrieve account details" });
                removePopup();
              }
            });
          } else {
            setLoader(false);
            setViewDataType(false);
            setPopup({ show: true, popupStatus: reportData?.message || "Failed to retrieve aggregator report" });
            removePopup();
          }
        });
      }else{
        setLoader(false);
         setPopup({ show: true, popupStatus: "User Didn't Completed the Consent Journey" });
                removePopup();
      }
    })
  };

  useEffect(() => {
    fetchData()
  }, [])

  // Filtered & Sorted transactions
  const filteredAndSortedTransactions = React.useMemo(() => {
    let txns = DetailsData?.transactions || [];

    // 1. Filter by Category / Type
    if (currentType) {
      txns = txns.filter(t => t.type.toLowerCase() === currentType.toLowerCase());
    }

    // 2. Search query
    if (searchQuery.trim()) {
      const query = searchQuery.toLowerCase();
      txns = txns.filter(t =>
        String(t.narration).toLowerCase().includes(query) ||
        String(t.valueDate).toLowerCase().includes(query)
      );
    }

    return txns;
  }, [DetailsData?.transactions, currentType, searchQuery]);

  // Paginated list
  const currentPaginatedData = React.useMemo(() => {
    const startIndex = (currentPage - 1) * itemsPerPage;
    const endIndex = startIndex + itemsPerPage;
    return filteredAndSortedTransactions.slice(startIndex, endIndex);
  }, [filteredAndSortedTransactions, currentPage, itemsPerPage]);

  const handlePagePagination = (e, value) => {
    setCurrentPage(value);
  };

  const closePopup = () => {
    setPopup({ show: false, popupStatus: '' })
  }

  const removePopup = () => {
    setTimeout(() => {
      closePopup()
    }, 5000)
  }

  const handleRegenrate = () => {
    fetchData()
  }

  const handleAnalysis = () => {
    setLoader(true);
    // const userId = "vHqQ6UkICrDo4Ve4alJNlYCCney6nRmz";
     const userId = allDetail?.userId || "";
    getRetrieveReportsAAByUserid(userId, "analysis", customHeaderTenant, (reportData) => {
      if (reportData?.status === 200) {
        getAADigitapByUserid(userId, customHeaderTenant, (analysisRes) => {
          setLoader(false);
          if (analysisRes?.status === 200 && analysisRes?.data) {
            setAnalysisData(analysisRes.data);
            setShowAnalysisModal(true);
          } else {
            setPopup({ show: true, popupStatus: analysisRes?.message || "Failed to retrieve digitap analysis data" });
            removePopup();
          }
        });
      } else {
        setLoader(false);
        setPopup({ show: true, popupStatus: reportData?.message || "Failed to retrieve aggregator report" });
        removePopup();
      }
    });
  }

  return (
    <>

      {loader ?
        <Loader />
        : ''}

      {
        popup?.show ?
          <Popup popupStatus={popup?.popupStatus} closePopup={closePopup} />
          : ''}

      <AnalysisModal 
        isOpen={showAnalysisModal} 
        onClose={() => setShowAnalysisModal(false)} 
        data={analysisData} 
      />

            <div>
              <button className="btn btn-primary" onClick={() => handleAnalysis()}>Analysis</button>
            </div>
      {
        viewDataType ?
          <>


            <div style={{ backgroundColor: DetailsData?.accountData?.summary?.status == "ACTIVE" ? '#f0fdf4' : "#fdf0f0", borderRadius: '0.5rem', padding: '15px', border: DetailsData?.accountData?.summary?.status == "ACTIVE" ? '1px solid #bbf7d0' : '1px solid #f7bbbb' }}>
              <h3 style={{ fontWeight: '600', color: '#1f2937', margin: ' 0 0 20px 0', fontSize: '20px' }}>Account Details</h3>
              <div style={{ display: 'grid', gridTemplateColumns: "repeat(4, minmax(0, 1fr))", gap: '1rem', fontSize: '0.875rem', lineHeight: '1.25rem' }}>
                <div style={{ marign: '0 0 10px 0' }}>
                  <p style={{ color: '#4b5563', fontSize: '16px' }}>Account Holder</p>
                  <p style={{ fontWeight: '500', fontSize: '14px' }}>{DetailsData?.holderData?.name}</p>
                </div>
                <div style={{ marign: '0 0 10px 0' }}>
                  <p style={{ color: '#4b5563', fontSize: '16px' }}>Account Number</p>
                  <p style={{ fontWeight: '500', fontSize: '14px' }}>{DetailsData?.parsedData?.accounts?.[0]?.maskedAccNumber}</p>
                </div>
                <div style={{ margin: '0 0 10px 0' }}>
                  <p style={{ color: '#4b5563', fontSize: '16px' }}>Account Type</p>
                  <p style={{ fontWeight: '500', fontSize: '14px' }}>{DetailsData?.accountData?.summary?.type}</p>
                </div>
                <div style={{ margin: '0 0 10px 0' }}>
                  <p style={{ color: '#4b5563', fontSize: '16px' }}>IFSC Code</p>
                  <p style={{ fontWeight: '500', fontSize: '14px' }}>{DetailsData?.accountData?.summary?.ifscCode}</p>
                </div>
                <div style={{ margin: '0 0 10px 0' }}>
                  <p style={{ color: '#4b5563', fontSize: '16px' }}>Branch</p>
                  <p style={{ fontWeight: '500', fontSize: '14px' }}>{DetailsData?.accountData?.summary?.branch}</p>
                </div>
                <div style={{ margin: '0 0 10px 0' }}>
                  <p style={{ color: '#4b5563', fontSize: '16px' }}>Account Status</p>
                  <p style={{ color: DetailsData?.accountData?.summary?.status == "ACTIVE" ? '#16a34a' : "#ff4c4c", fontSize: '14px', fontWeight: '500' }}>{DetailsData?.accountData?.summary?.status}</p>
                </div>
                <div style={{ margin: '0 0 10px 0' }}>
                  <p style={{ color: '#4b5563', fontSize: '16px' }}>Current Balance</p>
                  <p style={{ color: '#16a34a', fontSize: '14px', fontWeight: '700' }}>{formatCurrency(DetailsData?.accountData?.summary?.currentBalance)}</p>
                </div>

                <div style={{ margin: '0 0 10px 0' }}>
                  <p style={{ color: '#4b5563', fontSize: '16px' }}>MICR Code</p>
                  <p style={{ fontWeight: '500', fontSize: '14px' }}>{DetailsData?.accountData?.summary?.micrCode}</p>
                </div>
                <div style={{ marign: '0 0 10px 0' }}>
                  <p style={{ color: '#4b5563', fontSize: '16px' }}>Mobile</p>
                  <p style={{ fontWeight: '500', fontSize: '14px' }}>{DetailsData?.holderData?.mobile}</p>
                </div>
                <div style={{ marign: '0 0 10px 0' }}>
                  <p style={{ color: '#4b5563', fontSize: '16px' }}>PAN</p>
                  <p style={{ fontWeight: '500', fontSize: '14px' }}>{DetailsData?.holderData?.pan}</p>
                </div>
                <div style={{ marign: '0 0 10px 0' }}>
                  <p style={{ color: '#4b5563', fontSize: '16px' }}>Address</p>
                  <p style={{ fontWeight: '500', fontSize: '14px' }}>{DetailsData?.holderData?.address}</p>
                </div>

              </div>
            </div>

            <div style={{ background: '#fff', borderRadius: '0.5rem', border: '1px solid  #e5e7eb', margin: '20px 0' }}>
              <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', background: '#eff6ff', padding: '15px', flexWrap: 'wrap', gap: '10px' }}>
                <h3 style={{ fontWeight: '600', color: '#1f2937', margin: '0', fontSize: '20px' }}>Recent Transactions</h3>
                <div style={{ display: 'flex', gap: '10px', alignItems: 'center', flexWrap: 'wrap' }}>
                  {/* Page Size Filter */}
                  <select
                    value={itemsPerPage}
                    onChange={(e) => {
                      setItemsPerPage(Number(e.target.value));
                      setCurrentPage(1);
                    }}
                    style={{
                      padding: '8px 12px',
                      border: '1px solid #D3D9E9',
                      borderRadius: '5px',
                      width: '60px',
                      fontSize: '13px',
                      outline: 'none'
                    }}
                  >
                    <option value={5}>5</option>
                    <option value={10}>10</option>
                    <option value={15}>15</option>
                    <option value={20}>20</option>
                  </select>
                  {/* Category Filter */}
                  <select
                    value={currentType}
                    onChange={(e) => {
                      setcurrentType(e.target.value);
                      setCurrentPage(1);
                    }}
                    style={{
                      padding: '8px 12px',
                      border: '1px solid #D3D9E9',
                      borderRadius: '5px',
                      width: '130px',
                      fontSize: '13px',
                      outline: 'none'
                    }}
                  >
                    <option value="">Transactions</option>
                    <option value="credit">Credit</option>
                    <option value="debit">Debit</option>
                  </select>
                  {/* Search Bar */}
                  <input
                    type="text"
                    placeholder="Search..."
                    value={searchQuery}
                    onChange={(e) => {
                      setSearchQuery(e.target.value);
                      setCurrentPage(1);
                    }}
                    style={{
                      padding: '8px 12px',
                      border: '1px solid #D3D9E9',
                      borderRadius: '5px',
                      width: '200px',
                      fontSize: '13px',
                      outline: 'none'
                    }}
                  />
                </div>
              </div>
              {
                currentPaginatedData && currentPaginatedData.length > 0 ?
                  <>
                    <div className='customFinanceTable'>
                      <table>
                        <thead>
                          <tr>
                            <th style={{ textAlign: "left" }}>Date</th>
                            <th style={{ textAlign: "center" }}>Description</th>
                            <th style={{ textAlign: "center" }}>Type</th>
                            <th style={{ textAlign: "right" }}>Amount</th>
                            <th style={{ textAlign: "right" }}>Balance</th>
                          </tr>
                        </thead>
                        <tbody className="custom-divide-y">
                          {currentPaginatedData.map((txn, index) => (
                            <tr key={index}>
                              <td style={{ textAlign: "left" }}>{formatDateLatest(txn?.valueDate)}</td>
                              <td>{txn?.narration || ""}</td>
                              <td>
                                <span
                                  style={{
                                    display: 'inline-flex', padding: '8px', fontWeight: '500', borderRadius: '6px',
                                    background: txn?.type === 'CREDIT' ? "#d1fae5" : "#fee2e2",
                                    color: txn?.type === 'CREDIT' ? "#065f46" : "#991b1b"
                                  }}
                                >
                                  {txn?.type || ""}
                                </span>
                              </td>
                              <td style={{ textAlign: 'right', fontWeight: '500', color: txn?.type == "CREDIT" ? "#16a34a" : "#dc2626" }}>
                                {txn.type === 'CREDIT' ? '+' : '-'}{formatCurrency(txn?.amount)}
                              </td>
                              <td style={{ fontWeight: '500', textAlign: 'right' }}>
                                {formatCurrency(txn?.currentBalance)}
                              </td>
                            </tr>
                          ))
                          }
                        </tbody>
                      </table>
                    </div>
                    <div style={{ margin: '15px', display: 'flex', justifyContent: 'end' }}>
                      <Pagination
                        count={Math.ceil(filteredAndSortedTransactions.length / itemsPerPage)}
                        page={currentPage}
                        onChange={handlePagePagination}
                        variant="outlined"
                        color="primary" shape="rounded"
                      />
                    </div>
                  </>
                  :
                  <div style={{ textAlign: 'center', margin: '20px 0' }}>
                    <img src={Nodata} style={{ width: '40%' }} />
                  </div>}
            </div>

          </>
          :
          <h3 style={{ marginTop: '40px' }} className="text-center"><img src={Nodata} width="300px" /></h3>
      }


    </>
  )
}

const AnalysisModal = ({ isOpen, onClose, data }) => {
  const [activeTab, setActiveTab] = React.useState("summary");
  const [showAllRules, setShowAllRules] = React.useState(false);

  if (!isOpen || !data) return null;

  const { bankLevelSummary = {}, loanAnalysis = [], fraudAnalysis = [] } = data;

  const applicableRules = fraudAnalysis.filter(r => r.result === "applicable");
  const safeRules = fraudAnalysis.filter(r => r.result !== "applicable");

  // Tab Icon SVGs
  const iconSummary = (
    <svg style={{width:'auto', marginRight: '6px'}} width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.5" stroke-linecap="round" stroke-linejoin="round" >
      <rect x="3" y="3" width="18" height="18" rx="2" ry="2"/>
      <line x1="9" y1="9" x2="15" y2="9"/>
      <line x1="9" y1="13" x2="15" y2="13"/>
      <line x1="9" y1="17" x2="13" y2="17"/>
    </svg>
  );

  const iconLoans = (
    <svg style={{width:'auto', marginRight: '6px'}} width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.5" stroke-linecap="round" stroke-linejoin="round" >
      <rect x="3" y="4" width="18" height="18" rx="2" ry="2"/>
      <line x1="16" y1="2" x2="16" y2="6"/>
      <line x1="8" y1="2" x2="8" y2="6"/>
      <line x1="3" y1="10" x2="21" y2="10"/>
    </svg>
  );

  const iconAlerts = (
    <svg style={{width:'auto', marginRight: '6px'}} width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.5" stroke-linecap="round" stroke-linejoin="round" >
      <path d="M10.29 3.86L1.82 18a2 2 0 0 0 1.71 3h16.94a2 2 0 0 0 1.71-3L13.71 3.86a2 2 0 0 0-3.42 0z"/>
      <line x1="12" y1="9" x2="12" y2="13"/>
      <line x1="12" y1="17" x2="12.01" y2="17"/>
    </svg>
  );

  return (
    <div style={{
      position: 'fixed',
      top: 0,
      left: 0,
      right: 0,
      bottom: 0,
      backgroundColor: 'rgba(15, 23, 42, 0.7)',
      backdropFilter: 'blur(8px)',
      display: 'flex',
      justifyContent: 'center',
      alignItems: 'center',
      zIndex: 10000,
      padding: '20px',
      animation: 'fadeIn 0.25s ease-out'
    }}>
      <style>{`
        @keyframes fadeIn {
          from { opacity: 0; }
          to { opacity: 1; }
        }
        @keyframes slideUp {
          from { transform: translateY(24px); opacity: 0; }
          to { transform: translateY(0); opacity: 1; }
        }
        .dt-modal-container {
          background: #ffffff;
          border-radius: 20px;
          box-shadow: 0 25px 50px -12px rgba(0, 0, 0, 0.15);
          width: 100%;
          max-width: 980px;
          max-height: 85vh;
          display: flex;
          flex-direction: column;
          overflow: hidden;
          animation: slideUp 0.35s cubic-bezier(0.16, 1, 0.3, 1);
        }
        .dt-modal-header {
          padding: 22px 28px;
          border-bottom: 1px solid #f1f5f9;
          display: flex !important;
          justify-content: space-between !important;
          align-items: center !important;
          background: linear-gradient(135deg, #1e3a8a 0%, #2563eb 100%) !important;
          color: white !important;
        }
        .tab-btn {
          padding: 14px 22px;
          font-weight: 600;
          font-size: 14px;
          border: none;
          background: transparent;
          cursor: pointer;
          color: #64748b;
          border-bottom: 3px solid transparent;
          transition: all 0.2s;
          display: flex;
          align-items: center;
        }
        .tab-btn:hover {
          color: #2563eb;
          background: rgba(37, 99, 235, 0.03);
        }
        .tab-btn.active {
          color: #2563eb;
          border-bottom-color: #2563eb;
        }
        .summary-card {
          background: #ffffff;
          border: 1px solid #e2e8f0;
          border-radius: 14px;
          padding: 18px;
          display: flex;
          align-items: center;
          gap: 16px;
          transition: all 0.2s ease;
        }
        .summary-card:hover {
          transform: translateY(-2px);
          box-shadow: 0 10px 15px -3px rgba(0, 0, 0, 0.05);
          border-color: #cbd5e1;
        }
        .rules-scrollbar::-webkit-scrollbar {
          width: 6px;
          height: 6px;
        }
        .rules-scrollbar::-webkit-scrollbar-track {
          background: #f8fafc;
        }
        .rules-scrollbar::-webkit-scrollbar-thumb {
          background: #cbd5e1;
          border-radius: 4px;
        }
        .rules-scrollbar::-webkit-scrollbar-thumb:hover {
          background: #94a3b8;
        }
      `}</style>

      <div className="dt-modal-container">
        {/* Header */}
        <div className="dt-modal-header" style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', width: '100%' }}>
          <div style={{ textAlign: 'left' }}>
            <h2 style={{ margin: 0, fontSize: '20px', fontWeight: '700', letterSpacing: '-0.3px', color: 'white' }}>Digitap Statement Analysis</h2>
            <p style={{ margin: '4px 0 0 0', opacity: 0.85, fontSize: '13px', color: 'white' }}>Comprehensive risk audit, debt obligations and transaction summary</p>
          </div>
          <button 
            onClick={onClose}
            style={{
              background: 'rgba(255, 255, 255, 0.15)',
              border: 'none',
              borderRadius: '50%',
              width: '32px',
              height: '32px',
              cursor: 'pointer',
              color: 'white',
              display: 'flex',
              alignItems: 'center',
              justifyContent: 'center',
              transition: 'background 0.2s'
            }}
            onMouseEnter={(e) => e.target.style.background = 'rgba(255, 255, 255, 0.25)'}
            onMouseLeave={(e) => e.target.style.background = 'rgba(255, 255, 255, 0.15)'}
          >
            <svg width="auto" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.5" stroke-linecap="round" stroke-linejoin="round">
              <line x1="18" y1="6" x2="6" y2="18"/><line x1="6" y1="6" x2="18" y2="18"/>
            </svg>
          </button>
        </div>

        {/* Navigation Tabs */}
        <div style={{ display: 'flex', borderBottom: '1px solid #e2e8f0', background: '#f8fafc', padding: '0 24px' }}>
          <button className={`tab-btn ${activeTab === 'summary' ? 'active' : ''}`} onClick={() => setActiveTab('summary')}>
            {iconSummary} Bank Summary
          </button>
          <button className={`tab-btn ${activeTab === 'loans' ? 'active' : ''}`} onClick={() => setActiveTab('loans')}>
            {iconLoans} Loan Repayments ({loanAnalysis.length})
          </button>
          <button className={`tab-btn ${activeTab === 'fraud' ? 'active' : ''}`} onClick={() => setActiveTab('fraud')}>
            {iconAlerts} Risk Alerts ({applicableRules.length})
          </button>
        </div>

        {/* Content Area */}
        <div className="rules-scrollbar" style={{ padding: '28px', overflowY: 'auto', flex: 1, background: '#f8fafc' }}>
          
          {/* 1. Summary Tab */}
          {activeTab === 'summary' && (
            <div>
              <div style={{ display: 'grid', gridTemplateColumns: 'repeat(auto-fill, minmax(290px, 1fr))', gap: '20px' }}>
                
                {/* Avg EOD */}
                <div className="summary-card" style={{ borderLeft: '4px solid #2563eb' }}>
                  <div style={{ background: '#eff6ff', borderRadius: '10px', padding: '10px', display: 'flex', alignItems: 'center', justifyContent: 'center', color: '#2563eb' }}>
                    <svg width="auto" height="22" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round">
                      <path d="M20 12V8H6a2 2 0 0 1-2-2c0-1.1.9-2 2-2h14v4"/><path d="M4 6v12a2 2 0 0 0 2 2h14v-4"/><path d="M18 12a2 2 0 0 0-2 2v2a2 2 0 0 0 2 2h4v-6z"/>
                    </svg>
                  </div>
                  <div>
                    <div style={{ color: '#64748b', fontSize: '11px', fontWeight: '700', textTransform: 'uppercase', letterSpacing: '0.5px' }}>Avg EOD Balance</div>
                    <div style={{ color: '#1e3a8a', fontSize: '20px', fontWeight: '800', marginTop: '4px' }}>
                      {formatCurrency(bankLevelSummary["Average EOD Balance"])}
                    </div>
                  </div>
                </div>

                {/* Max Balance */}
                <div className="summary-card" style={{ borderLeft: '4px solid #10b981' }}>
                  <div style={{ background: '#ecfdf5', borderRadius: '10px', padding: '10px', display: 'flex', alignItems: 'center', justifyContent: 'center', color: '#10b981' }}>
                    <svg width="auto" height="22" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round">
                      <polyline points="23 6 13.5 15.5 8.5 10.5 1 18"/><polyline points="17 6 23 6 23 12"/>
                    </svg>
                  </div>
                  <div>
                    <div style={{ color: '#64748b', fontSize: '11px', fontWeight: '700', textTransform: 'uppercase', letterSpacing: '0.5px' }}>Max Balance</div>
                    <div style={{ color: '#065f46', fontSize: '20px', fontWeight: '800', marginTop: '4px' }}>
                      {formatCurrency(bankLevelSummary["Max Balance"])}
                    </div>
                  </div>
                </div>

                {/* Median Balance */}
                <div className="summary-card" style={{ borderLeft: '4px solid #f59e0b' }}>
                  <div style={{ background: '#fffbeb', borderRadius: '10px', padding: '10px', display: 'flex', alignItems: 'center', justifyContent: 'center', color: '#f59e0b' }}>
                    <svg width="auto" height="22" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round">
                      <circle cx="12" cy="12" r="10"/><line x1="12" y1="8" x2="12" y2="16"/><line x1="8" y1="12" x2="16" y2="12"/>
                    </svg>
                  </div>
                  <div>
                    <div style={{ color: '#64748b', fontSize: '11px', fontWeight: '700', textTransform: 'uppercase', letterSpacing: '0.5px' }}>Median EOD Balance</div>
                    <div style={{ color: '#92400e', fontSize: '20px', fontWeight: '800', marginTop: '4px' }}>
                      {formatCurrency(bankLevelSummary["Median EOD Balance"])}
                    </div>
                  </div>
                </div>

                {/* Total Credits */}
                <div className="summary-card" style={{ borderLeft: '4px solid #3b82f6' }}>
                  <div style={{ background: '#eff6ff', borderRadius: '10px', padding: '10px', display: 'flex', alignItems: 'center', justifyContent: 'center', color: '#3b82f6' }}>
                    <svg width="auto" height="22" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round">
                      <circle cx="12" cy="12" r="10"/><polyline points="12 8 8 12 12 16"/><line x1="16" y1="12" x2="8" y2="12"/>
                    </svg>
                  </div>
                  <div>
                    <div style={{ color: '#64748b', fontSize: '11px', fontWeight: '700', textTransform: 'uppercase', letterSpacing: '0.5px' }}>Total Credits</div>
                    <div style={{ color: '#1d4ed8', fontSize: '18px', fontWeight: '800', marginTop: '4px' }}>
                      {formatCurrency(bankLevelSummary["Total Amount of Credit Transactions"])}
                    </div>
                    <div style={{ color: '#94a3b8', fontSize: '12px', marginTop: '2px', fontWeight: '500' }}>
                      {bankLevelSummary["Total No. of Credit Transactions"]} Transactions
                    </div>
                  </div>
                </div>

                {/* Total Debits */}
                <div className="summary-card" style={{ borderLeft: '4px solid #ef4444' }}>
                  <div style={{ background: '#fef2f2', borderRadius: '10px', padding: '10px', display: 'flex', alignItems: 'center', justifyContent: 'center', color: '#ef4444' }}>
                    <svg width="auto" height="22" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round">
                      <circle cx="12" cy="12" r="10"/><polyline points="12 16 16 12 12 8"/><line x1="8" y1="12" x2="16" y2="12"/>
                    </svg>
                  </div>
                  <div>
                    <div style={{ color: '#64748b', fontSize: '11px', fontWeight: '700', textTransform: 'uppercase', letterSpacing: '0.5px' }}>Total Debits</div>
                    <div style={{ color: '#b91c1c', fontSize: '18px', fontWeight: '800', marginTop: '4px' }}>
                      {formatCurrency(bankLevelSummary["Total Amount of Debit Transactions"])}
                    </div>
                    <div style={{ color: '#94a3b8', fontSize: '12px', marginTop: '2px', fontWeight: '500' }}>
                      {bankLevelSummary["Total No. of Debit Transactions"]} Transactions
                    </div>
                  </div>
                </div>

                {/* EMI Payments */}
                <div className="summary-card" style={{ borderLeft: '4px solid #a855f7' }}>
                  <div style={{ background: '#faf5ff', borderRadius: '10px', padding: '10px', display: 'flex', alignItems: 'center', justifyContent: 'center', color: '#a855f7' }}>
                    <svg width="auto" height="22" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round">
                      <path d="M21 7.5V6a2 2 0 0 0-2-2H5a2 2 0 0 0-2 2v14a2 2 0 0 0 2 2h3.5"/><circle cx="18" cy="18" r="4"/><path d="M18 16.5V18l1 1"/>
                    </svg>
                  </div>
                  <div>
                    <div style={{ color: '#64748b', fontSize: '11px', fontWeight: '700', textTransform: 'uppercase', letterSpacing: '0.5px' }}>EMI / Loan Obligations</div>
                    <div style={{ color: '#7e22ce', fontSize: '18px', fontWeight: '800', marginTop: '4px' }}>
                      {formatCurrency(bankLevelSummary["Total Amount of EMI / loan Payments"] || bankLevelSummary["Total Amount of EMI / loan payments"])}
                    </div>
                    <div style={{ color: '#94a3b8', fontSize: '12px', marginTop: '2px', fontWeight: '500' }}>
                      {bankLevelSummary["No. of EMI / loan payments"]} Payments
                    </div>
                  </div>
                </div>

              </div>
            </div>
          )}

          {/* 2. Loan Analysis Tab */}
          {activeTab === 'loans' && (
            <div>
              {loanAnalysis.length === 0 ? (
                <div style={{ textAlign: 'center', padding: '60px 20px', background: 'white', borderRadius: '16px', border: '1px solid #e2e8f0' }}>
                  <svg width="auto" height="48" viewBox="0 0 24 24" fill="none" stroke="#94a3b8" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round" style={{ marginBottom: '12px' }}>
                    <circle cx="12" cy="12" r="10"/><line x1="12" y1="8" x2="12" y2="12"/><line x1="12" y1="16" x2="12.01" y2="16"/>
                  </svg>
                  <p style={{ margin: 0, fontWeight: '600', color: '#475569', fontSize: '15px' }}>No Loan/EMI repayments detected</p>
                  <p style={{ margin: '4px 0 0 0', color: '#94a3b8', fontSize: '13px' }}>The parsing rules did not find any corresponding debit transactions.</p>
                </div>
              ) : (
                <div className='customFinanceTable' style={{ background: 'white', padding: '10px', borderRadius: '16px', border: '1px solid #e2e8f0' }}>
                  <table style={{ width: '100%' }}>
                    <thead>
                      <tr>
                        <th style={{ textAlign: 'left' }}>Date</th>
                        <th style={{ textAlign: 'left' }}>Narration</th>
                        <th style={{ textAlign: 'left' }}>Category</th>
                        <th style={{ textAlign: 'right' }}>Amount</th>
                        <th style={{ textAlign: 'right' }}>Balance</th>
                      </tr>
                    </thead>
                    <tbody className="custom-divide-y">
                      {loanAnalysis.map((loan, idx) => (
                        <tr key={idx}>
                          <td style={{ textAlign: 'left', fontWeight: '500' }}>{loan.date}</td>
                          <td style={{ textAlign: 'left', maxWidth: '340px', overflow: 'hidden', textOverflow: 'ellipsis', whiteSpace: 'nowrap' }}>
                            {loan.narration}
                          </td>
                          <td style={{ textAlign: 'left' }}>
                            <span style={{
                              padding: '4px 10px',
                              borderRadius: '12px',
                              fontSize: '11px',
                              fontWeight: '700',
                              background: '#f3e8ff',
                              color: '#6b21a8',
                              display: 'inline-flex',
                              alignItems: 'center'
                            }}>
                              <span style={{ width: '6px', height: '6px', borderRadius: '50%', background: '#a855f7', marginRight: '6px' }} />
                              {loan.category}
                            </span>
                          </td>
                          <td style={{ textAlign: 'right', fontWeight: '700', color: '#ef4444' }}>
                            {formatCurrency(loan.amount)}
                          </td>
                          <td style={{ textAlign: 'right', color: '#475569', fontWeight: '500' }}>
                            {formatCurrency(loan.balance)}
                          </td>
                        </tr>
                      ))}
                    </tbody>
                  </table>
                </div>
              )}
            </div>
          )}

          {/* 3. Fraud / Risk Alerts Tab */}
          {activeTab === 'fraud' && (
            <div>
              {/* Applicable/Risk Rules first */}
              <div style={{ display: 'flex', flexDirection: 'column', gap: '20px', marginBottom: '24px' }}>
                {applicableRules.map((rule, idx) => (
                  <div key={idx} style={{
                    background: '#ffffff',
                    border: '1px solid #fca5a5',
                    borderRadius: '16px',
                    padding: '20px',
                    boxShadow: '0 4px 6px -1px rgba(220, 38, 38, 0.03)'
                  }}>
                    <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', borderBottom: '1px solid #fee2e2', paddingBottom: '12px', marginBottom: '14px' }}>
                      <div style={{ display: 'flex', alignItems: 'center', gap: '8px' }}>
                        <span style={{ display: 'flex', alignItems: 'center', color: '#dc2626' }}>
                          <svg width="auto" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.5" stroke-linecap="round" stroke-linejoin="round">
                            <path d="M10.29 3.86L1.82 18a2 2 0 0 0 1.71 3h16.94a2 2 0 0 0 1.71-3L13.71 3.86a2 2 0 0 0-3.42 0z"/><line x1="12" y1="9" x2="12" y2="13"/><line x1="12" y1="17" x2="12.01" y2="17"/>
                          </svg>
                        </span>
                        <span style={{ fontWeight: '700', color: '#991b1b', fontSize: '15px' }}>{rule.type}</span>
                      </div>
                      <span style={{
                        background: '#fee2e2',
                        color: '#dc2626',
                        padding: '4px 12px',
                        borderRadius: '20px',
                        fontSize: '11px',
                        fontWeight: '800',
                        textTransform: 'uppercase',
                        letterSpacing: '0.5px'
                      }}>
                        Triggered Alert
                      </span>
                    </div>

                    {rule.transactions && rule.transactions.length > 0 && (
                      <div style={{ background: '#f8fafc', borderRadius: '12px', padding: '14px', border: '1px solid #e2e8f0' }}>
                        <div style={{ fontWeight: '700', fontSize: '12px', color: '#475569', marginBottom: '10px', display: 'flex', alignItems: 'center', gap: '6px' }}>
                          <svg width="auto" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.5" stroke-linecap="round" stroke-linejoin="round">
                            <line x1="8" y1="6" x2="21" y2="6"/><line x1="8" y1="12" x2="21" y2="12"/><line x1="8" y1="18" x2="21" y2="18"/><line x1="3" y1="6" x2="3.01" y2="6"/><line x1="3" y1="12" x2="3.01" y2="12"/><line x1="3" y1="18" x2="3.01" y2="18"/>
                          </svg>
                          Matching Rule Transactions ({rule.transactions.length})
                        </div>
                        <div className="customFinanceTable" style={{ overflowX: 'auto' }}>
                          <table style={{ width: '100%', fontSize: '12px' }}>
                            <thead>
                              <tr>
                                <th style={{ padding: '8px 10px', textAlign: 'left' }}>Date</th>
                                <th style={{ padding: '8px 10px', textAlign: 'left' }}>Narration</th>
                                <th style={{ padding: '8px 10px', textAlign: 'right' }}>Amount</th>
                                <th style={{ padding: '8px 10px', textAlign: 'right' }}>Balance</th>
                              </tr>
                            </thead>
                            <tbody className="custom-divide-y">
                              {rule.transactions.map((t, tIdx) => {
                                const isDebit = String(t.narration).toLowerCase().includes('/dr/') || String(t.category).toLowerCase().includes('transfer to') || t.amount < 0;
                                return (
                                  <tr key={tIdx}>
                                    <td style={{ padding: '8px 10px', fontWeight: '500' }}>{t.transaction_date || t.date}</td>
                                    <td style={{ padding: '8px 10px', maxWidth: '300px', overflow: 'hidden', textOverflow: 'ellipsis', whiteSpace: 'nowrap' }} title={t.narration}>
                                      {t.narration}
                                    </td>
                                    <td style={{ padding: '8px 10px', textAlign: 'right', fontWeight: '700', color: isDebit ? '#ef4444' : '#10b981' }}>
                                      {isDebit ? '-' : '+'}{formatCurrency(Math.abs(t.amount))}
                                    </td>
                                    <td style={{ padding: '8px 10px', textAlign: 'right', color: '#64748b', fontWeight: '500' }}>
                                      {formatCurrency(t.balance)}
                                    </td>
                                  </tr>
                                );
                              })}
                            </tbody>
                          </table>
                        </div>
                      </div>
                    )}
                  </div>
                ))}
              </div>

              {/* Safe / Not-triggered Section */}
              <div style={{ borderTop: '1px solid #e2e8f0', paddingTop: '20px' }}>
                <button 
                  onClick={() => setShowAllRules(!showAllRules)}
                  style={{
                    background: '#ffffff',
                    border: '1px solid #cbd5e1',
                    borderRadius: '8px',
                    color: '#475569',
                    padding: '8px 16px',
                    cursor: 'pointer',
                    fontWeight: '600',
                    fontSize: '13px',
                    display: 'flex',
                    alignItems: 'center',
                    gap: '6px',
                    boxShadow: '0 1px 2px 0 rgba(0, 0, 0, 0.05)',
                    transition: 'all 0.15s ease'
                  }}
                  onMouseEnter={(e) => {
                    e.currentTarget.style.background = '#f8fafc';
                    e.currentTarget.style.borderColor = '#94a3b8';
                  }}
                  onMouseLeave={(e) => {
                    e.currentTarget.style.background = '#ffffff';
                    e.currentTarget.style.borderColor = '#cbd5e1';
                  }}
                >
                  {showAllRules ? (
                    <>
                      <svg style={{width:'auto'}} width="auto" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.5" stroke-linecap="round" stroke-linejoin="round">
                        <polyline points="18 15 12 9 6 15"/>
                      </svg>
                      Hide Passed Rules
                    </>
                  ) : (
                    <>
                      <svg style={{width:'auto'}} width="auto" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.5" stroke-linecap="round" stroke-linejoin="round">
                        <polyline points="6 9 12 15 18 9"/>
                      </svg>
                      Show Passed Rules ({safeRules.length})
                    </>
                  )}
                </button>
                
                {showAllRules && (
                  <div style={{ display: 'grid', gridTemplateColumns: 'repeat(auto-fill, minmax(290px, 1fr))', gap: '12px', marginTop: '16px', animation: 'fadeIn 0.2s ease-out' }}>
                    {safeRules.map((rule, idx) => (
                      <div key={idx} style={{
                        background: '#ffffff',
                        border: '1px solid #e2e8f0',
                        borderRadius: '10px',
                        padding: '12px 14px',
                        display: 'flex',
                        alignItems: 'center',
                        justifyContent: 'space-between'
                      }}>
                        <span style={{ fontSize: '13px', color: '#475569', fontWeight: '500' }}>{rule.type}</span>
                        <span style={{
                          display: 'inline-flex',
                          alignItems: 'center',
                          color: '#10b981',
                          fontWeight: '700',
                          fontSize: '11px',
                          textTransform: 'uppercase',
                          gap: '4px'
                        }}>
                          <svg style={{width:'auto'}} width="auto" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="3" stroke-linecap="round" stroke-linejoin="round">
                            <polyline points="20 6 9 17 4 12"/>
                          </svg>
                          Passed
                        </span>
                      </div>
                    ))}
                  </div>
                )}
              </div>

            </div>
          )}

        </div>

        {/* Footer */}
        <div style={{
          padding: '18px 28px',
          borderTop: '1px solid #f1f5f9',
          display: 'flex',
          justifyContent: 'flex-end',
          background: '#f8fafc'
        }}>
          <button 
            className="btn btn-secondary" 
            onClick={onClose}
            style={{ padding: '10px 20px', borderRadius: '8px', fontSize: '13px', fontWeight: '600' }}
          >
            Close Report
          </button>
        </div>
      </div>
    </div>
  );
};

